import React from 'react'
import { Link } from 'react-router-dom'
import {Textarea, InputFile} from 'components/common'
import user, {User} from './user'
import FeedComponent from './feed-component'
import AdvertisementView from './advertisement-view'


class Profile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {editing: 0};
	}

	init(props) {
		const { params } = props.match || {};

		this.uid = params.uid || hp.store.uid;
		this.user = user.get(this.uid);
		this.profile = this.user ? this.user.profile : null;
		this.is_my_profile = user.canEditProfile(this.uid);
	}

	componentWillReceiveProps(props) {
		this.init(props);
	}

	onEditImage(title, type, ev) {
		if (ev) {
			ev.preventDefault();
		}
		let file = null

		mbox.modal(
			<div className="content">
				<InputFile type='image' onChange={e => file = e.currentTarget.files[0]} />
				<span className="float-right">{__('socials_dims', {ratio: __('socials_dims_' + type)})}</span>
			</div>, {
				title: title,
				buttons: [
					{
						type: 'primary',
						text: __('buttons_apply'),
						icon: 'check',
						onClick: () => {
							if (!file) {
								return alert(__('socials_image_not_set'));
							}
							User.submitImage(file, type, () => {
								this.forceUpdate()
								mbox.dismiss()
							});
						}
					},
					'cancel'
				]
			}
		);
	}

	onSave(profile) {
		http.post('/home/saveUser.json', { user: profile }, (response, success) => {
			this.setState({
				profile_bak: null,
				editing: 0
			});
		});
	}

	onStartEdit(profile, editing) {
		this.setState({
			profile_bak: Object.assign({}, profile),
			editing: editing
		});
	}

	onCancelEdit(profile) {
		Object.assign(profile, this.state.profile_bak);
		this.setState({
			profile_bak: null,
			editing: 0
		});
	}

	renderField(pf, label, renderer) {
		// atividade, site, nome e morada aparecem sempre
		const fixed_pfs = 1 | 2 | 16 | 32 | 64;
		let {privacy_fields} = this.profile;
		//const pfs = privacy_fields === null || privacy_fields === undefined ? 511 : (privacy_fields || 0);
		const pfs = privacy_fields || 0;
		const visibility = !this.is_my_profile ? null : ((pf & fixed_pfs)
			? <em className="la la-check"></em>
			: <em
				className={classNames("la action",(pfs & pf) > 0 ? "la-unlock btn-success" : "la-lock btn-warning")}
				title={__((pfs & pf) > 0 ? "socials_field_shared" : "socials_field_locked")}
				onClick={() => {
					privacy_fields = parseInt(privacy_fields || 0);
					this.profile.privacy_fields = (privacy_fields & pf) > 0
						? (privacy_fields - pf)
						: (privacy_fields | pf);
					http.post('/home/savePrivacyField.json', {
						silent: true,
						data: {uid: this.uid, pfs: this.profile.privacy_fields},
					}, response => this.forceUpdate())
				}}
			/>)
		return (
			<div className="field">
				{visibility}
				<em className={label} />
				{user.isLoggedIn() || (pf & fixed_pfs) || (pfs & pf) ? renderer() : <span>-</span>}
			</div>
		);
	}

	renderProfile() {
		const {profile} = this;
		const style = null; // is_my_profile ? {border: '1px dotted #eee'} : null;

		return (
			<div className="profile" style={style}>
				{/*is_my_profile
					? <div className="btn-group-xs btn-circular float-right">
						<button className="btn btn-primary" onClick={this.onStartEdit.bind(this, profile, 1)} title={__('entities_edit')}>
							<em className="la la-pencil" />
						</button>
					</div>
					: null*/}
				{this.renderField(1, 'la la-building', () => <span className="bold">{profile.name}</span>)}
				{this.renderField(2, 'la la-link', () => <a target="_blank" href={profile.site}>{profile.site}</a>)}
				{this.renderField(4, 'la la-at', () => <a href={"mailto:" + profile.email1}>{profile.email1}</a>)}
				{this.renderField(8, 'la la-phone', () => <span>{profile.phone1}</span>)}
				{this.renderField(16, 'la la-envelope', () => <span>{profile.street}</span>)}
				{this.renderField(32, 'la la-envelope', () => <span>{profile.postal_description}</span>)}
				{this.renderField(64, 'la la-industry', () => <span>{profile.activity}</span>)}
			</div>
		);
	}

	renderAboutUs() {
		const {profile, is_my_profile} = this;
		const title = <h6 className="float-left">{__('socials_aboutus')}</h6>

		if (this.state.editing == 2) {
			return (
				<div className="row row-cols-1 mx-0 feed">
					<div className="col">
						<div className="aboutus">
							{title}
							<div className="btn-group-xs float-right">
								<button className="btn btn-light btn-circular" onClick={this.onCancelEdit.bind(this, profile)} title={__('buttons_cancel')}>
									<em className="la la-undo" />
								</button>
								<button className="btn btn-primary btn-circular" onClick={this.onSave.bind(this, profile)} title={__('buttons_save')}>
									<em className="la la-check" />
								</button>
							</div>
							<div className="float-right btn-group btn-group-sm mr-2">
								<button className={classNames("btn", this.state.about_field != 'about_us_de' ? 'btn-primary' : 'btn-light')} onClick={() => this.setState({about_field: null})}>
									{hp.store.locales['pt-pt'].country}
								</button>
								<button className={classNames("btn", this.state.about_field == 'about_us_de' ? 'btn-primary' : 'btn-light')} onClick={() => this.setState({about_field: 'about_us_de'})}>
									{hp.store.locales['de-de'].country}
								</button>
							</div>
							<div className="clearfix" />
							<Textarea model={profile} name={this.state.about_field || "about_us"} rows={10} maxLength={500} className="form-control about_us" />
							<div className="float-right">max: 500</div>
						</div>
					</div>
				</div>
			);
		}
		return (
			<div className="row row-cols-1 mx-0 feed">
				<div className="col">
					<div className="aboutus">
						{title}
						{is_my_profile
							? <div className="btn-group-xs float-right">
								<button className="btn btn-primary btn-circular" onClick={this.onStartEdit.bind(this, profile, 2)} title={__('socials_aboutus_edit')}>
									<em className="la la-pencil" />
								</button>
							</div>
							: null
						}
						<div className="clearfix" />
						<div>{hp.settings.locale == 'de-de' && profile.about_us_de ? profile.about_us_de : profile.about_us}</div>
					</div>
				</div>
			</div>
		);
	}

	onFollow() {
		const { params } = this.props.match || {};
		const uid = params.uid || hp.store.uid;

		user.toggleFollow(uid).then(() => this.forceUpdate());
	}

	render() {
		if (!this.profile || this.profile.id != this.uid) {
			this.init(this.props);
		}
		const {uid, profile, is_my_profile} = this;
		const style = profile && profile.cover
			? {backgroundImage: `url(${profile.cover})`}
			: null;
		const style_logo = is_my_profile ? {border: '1px dotted #eee'} : null;
		let follow = null;
		const followed_members = hp.store.followers.map(member =>
			<div key={member.id} className="list-group">
				<Link className="list-group-item" to={"/home/profile/" + member.id}>
					<img src={member.img || null} alt="" className="img-thumbnail" />
					<span>{member.name}</span>
				</Link>
			</div>
		);
		const is_following = !is_my_profile && hp.store.followers.get(uid) != null;
		let about_us = profile ? this.renderAboutUs() : null;
		const usrp = profile || user.get(uid) ? user.get(uid).profile : null;

		if (!is_my_profile) {
			follow =
				<div className="follow">
					{user.isLoggedIn() ? [
						<button key={1} className={"btn btn-" + (is_following ? 'success' : 'light')} onClick={this.onFollow.bind(this)}>
							<em className={"la la-" + (is_following ? 'check-double' : 'check')} />
							<span>{__('users_follow')}</span>
						</button>,
						<Link key={2} to={"/home/chat/" + uid} className="btn btn-light">
							<em className="la la-comments" />
							<span>{__('buttons_send_msg')}</span>
						</Link>
					] : null}
					<a className="btn btn-light" href={"mailto:?body=" + location.href}>
						<em className="la la-share" />
						<span>{__('buttons_share')}</span>
					</a>
				</div>
		}
		return (
			<div>
				<div className="banner mb-4" style={style}>
					{is_my_profile
					  ? <div className="btn-group-xs btn-circular float-left">
							<button className="btn btn-primary" onClick={this.onEditImage.bind(this, __('socials_cover_set'), 'cover')} title={__('socials_cover_set')}>
								<em className="la la-pencil" />
							</button>
						</div>
					  : null}
					<div className="row pt-5">
						<div className="col-xs-12 col-md-2 ml-md-5">
							<a href={usrp ? (usrp.site || null) : null} target="_blank" className="logo" style={style_logo}>
							{is_my_profile
								? <div className="btn-group-xs btn-circular float-right">
									<button className="btn btn-primary" onClick={this.onEditImage.bind(this, __('socials_logo_set'), 'profile')} title={__('socials_logo_set')}>
										<em className="la la-pencil" />
									</button>
								</div>
								: null}
								<img className="img-fluid d-block mx-auto my-auto" src={user.logo(uid, 'profile')} alt=""/>
							</a>
						</div>
						<div className="col-xs-12 col-md-6 col-lg-7">
							{profile ? this.renderProfile() : null}
						</div>
						<div className="col-xs-12 col-md-3 col-lg-2">
							{follow}
						</div>
					</div>
				</div>
				<div className="row justify-content-center no-gutters mt-1">
					<div className="col-xs-12 col-md-2">
						<div className="row mx-0 no-gutters">
							<div className="col">
								<div className={classNames("followers", is_my_profile ? "editable" : null)}>
									<h6>{__('socials_following')}</h6>
									{followed_members}
								</div>
							</div>
						</div>
					</div>

					<div className="col-xs-12 col-md-8">
						{about_us}
						<FeedComponent uid={uid} onUpdate={() => this.forceUpdate()} editable={true} />
					</div>
					<div className="col-xs-12 col-md-2">
						<h6>{__('socials_advertisement')}</h6>
						<div className="row mx-0 no-gutters advertisement">
							<AdvertisementView alias="advertisement-profile" />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Profile
